module.exports = __webpack_public_path__ + "assets/img/block-right-hover-ed7973f6.png";